import React, { useState, useEffect } from 'react';
import {
  Paper,
  Grid,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useApiBaseUrl } from '../context/ApiContext';

const PreOrderReview = () => {
  const [preOrderItems, setPreOrderItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [reviewItems, setReviewItems] = useState([]);

  const ApiBaseUrl = useApiBaseUrl();

  useEffect(() => {
    fetchPreOrderItems();
  }, []);

  const fetchPreOrderItems = async () => {
    try {
      const response = await fetch(`${ApiBaseUrl}/api/sales/GetPreOrderItemsForReview`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setPreOrderItems(data);
    } catch (error) {
      console.error('Error fetching pre-order items:', error);
    }
  };

  const fetchPreOrdersForReview = async (preOrderItemId) => {
    try {
      setReviewItems([]);
      const response = await fetch(`${ApiBaseUrl}/api/sales/${preOrderItemId}/GetPreOrdersForReview`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setReviewItems(data);
    } catch (error) {
      console.error('Error fetching pre-orders for review:', error);
    }
  };

  const handleItemSelect = (item) => {
    setSelectedItem(null);
    setSelectedItem(item);
    setEditingCustomerId(null);
    fetchPreOrdersForReview(item.preOrderItemId);
  };

  const groupByDueDate = (items) => {
    const groups = items.reduce((acc, item) => {
      const date = new Date(item.preorderDueDate);
      const dateStr = date.toLocaleDateString();
      if (!acc[dateStr]) {
        acc[dateStr] = { date, items: [] };
      }
      acc[dateStr].items.push(item);
      return acc;
    }, {});

    // Convert the groups object to an array and sort by date descending
    return Object.entries(groups)
      .sort((a, b) => b[1].date - a[1].date) // Sort descendingly by date
      .map(([dateStr, group]) => [dateStr, group.items]);
  };

  const [editingCustomerId, setEditingCustomerId] = useState(null);
  const handlePreOrderClick = (customerId, preOrderId, qty, itemNo) => {
    setEditingCustomerId(customerId);
    //console.log(`Customer ID: ${customerId}, Pre-Order ID: ${preOrderId}, Qty: ${qty}`);
  };

  async function handleQtyChange (e, customerId, preOrderId, preOrderItemId, itemNo) {
    //setEditingCustomerId(customerId);
    console.log(`Customer ID: ${customerId}, Pre-Order ID: ${preOrderId}, Qty: ${e.target.value}, Pre-Order Item ID: ${selectedItem.preOrderItemId}, Item No: ${selectedItem.itemNo}`);
    const parameters = {
      PreOrderItemId: preOrderItemId,
      CustomerId: customerId,
      Qty: e.target.value,
      No: itemNo
    };

    try {
      const response = await fetch(`${ApiBaseUrl}/api/sales/AdminUpdatePreOrderQty`, {  
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(parameters)
      });

      if (!response.ok) throw new Error('Error updating pre-order');
      const data = response.json(); 
      console.log(data);
      setEditingCustomerId(null);
      fetchPreOrdersForReview(preOrderItemId);
    } catch (error) {
      console.error('Error updating pre-order quantity:', error);
    }

  };

  return (
    <Grid container spacing={2} style={{marginTop: '8px'}}>
      <Grid item xs={4}>
        <Paper elevation={3} style={{ height: '80vh', overflow: 'auto', overflowX: 'hidden' }}>
          <Typography variant="h6" gutterBottom style={{marginTop: '16px'}}>
            Pre-Order Items
          </Typography>
          <List dense>
            {groupByDueDate(preOrderItems).map(([date, items], index) => (
              <React.Fragment key={date}>
                {index > 0 && <Divider />}
                <ListItem>
                  <Typography variant="subtitle2" style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    PRE ORDERS DUE: {date}
                  </Typography>
                </ListItem>
                {items.map((item) => (
                  <ListItem
                    style={{maxHeight: '40px', overflow: 'hidden'}}
                    key={item.preOrderItemId}
                    button
                    dense
                    onClick={() => handleItemSelect(item)}
                    selected={selectedItem?.preOrderItemId === item.preOrderItemId}
                  >
                    <Checkbox
                      checked={selectedItem?.preOrderItemId === item.preOrderItemId}
                      edge="start"
                      size="small"
                    />
                    <ListItemText
                      primary={item.itemNo}
                      secondary={item.description}
                      primaryTypographyProps={{ variant: 'body2', noWrap: true }}
                      secondaryTypographyProps={{ variant: 'caption', noWrap: true }}
                      style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
                    />
                  </ListItem>
                ))}
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Grid>
      <Grid item xs={8}>
        <Paper elevation={3} style={{ height: '78vh', overflow: 'auto', overflowX: 'hidden', padding: '16px' }}>
          {selectedItem ? (
            <>
              <Typography variant="h6" gutterBottom style={{textAlign: 'left'}}>
                Selected Pre Order Item:  <span style={{marginLeft: '30px', fontWeight: 'bold', fontSize: '24px'}}>{selectedItem.description}</span>
              </Typography>
              <TableContainer component={Paper}>
                <Table size="small" aria-label="review items table">
                  <TableHead>
                    <TableRow>
                      {['Customer', 'Qty', 'Submitted Date'].map((header) => (
                        <TableCell
                          key={header}
                          style={{ fontWeight: 'bold', padding: '8px' }}>
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {reviewItems.map((item) => (
                      <TableRow 
                        key={item.customerId} 
                        style={{
                          height: '24px',
                          transition: 'background-color 0.3s',
                        }}
                        hover
                      >
                        <TableCell style={{ padding: '0px 2px', fontSize: '0.8rem' }}>
                          {item.customerId} - {item.customerName}
                        </TableCell>
                        <TableCell style={{ padding: '0px 2px', fontSize: '0.8rem' }}>
                          {editingCustomerId === item.customerId ? (
                            <input
                              type="text"
                              //value={}
                              //onChange={(e) => handleQtyChange(e, item.customerId, item.preOrderId)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  handleQtyChange(e, item.customerId, item.preOrderId, selectedItem.preOrderItemId, selectedItem.itemNo)
                                  //handlePreOrderClick(item.customerId, item.preOrderId, e.target.value, item.itemNo);
                                  e.target.blur();
                                }
                              }}
                              //onBlur={() => handlePreOrderClick(item.customerId, item.preOrderId, item.qty, item.itemNo)}
                              style={{ width: '30px', textAlign: 'center' }}
                            />
                          ) : (
                            <a href="#" style={{ textDecoration: 'none' }} onClick={() => handlePreOrderClick(item.customerId, item.preOrderId, item.qty)}>
                              {item.qty}
                            </a>
                          )}
                        </TableCell>
                        <TableCell style={{ padding: '0px 2px', fontSize: '0.8rem' }}>
                          {item.submittedDate && new Date(item.submittedDate).getFullYear() !== 1969
                            ? new Date(item.submittedDate).toLocaleDateString()
                            : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Typography variant="body1">Select a pre-order item to view details</Typography>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PreOrderReview;